import React from "react"

import { NO, YES } from "const"
import { LangType } from "client/store"
import { TableColumnEditable } from "client/components"


import { MtPackage } from "server/models"

import TableSelect from "../components/select"

const Okr = (lang: LangType) => {
    const columns: TableColumnEditable[] = [
        {
            field: "okrModuleAccess",
            header: lang.okrModuleAccess,
            formatter: (packg: MtPackage) => {
                const { okrModuleAccess } = packg.settingsParsed
                return lang[okrModuleAccess]
            },
            focusedFormatter: (packg: MtPackage) => {
                const { okrModuleAccess } = packg.settingsParsed
                return (
                    <TableSelect
                        text={lang[okrModuleAccess]}
                        label={lang.okrModuleAccess}
                        property={{ okrModuleAccess }}
                        propertyArray={[NO, YES]}
                    />
                )
            },
        },
    ]

    return columns
}
export default Okr
